<template>
    <div class="page">
        <section class="cContent">
            <table>
                <tr>
                    <th>课程名称</th>
                    <th>单价</th>
                    <th>金额</th>
                </tr>
                <tr v-for="item in orderItems" v-bind:key="'cart'+item.goods_id">
                    <td>
                        <div class="img-box">
                            <img @click="$router.push('/course/'+item.id)" :src="'/imgs/'+item.display_img" alt/>
                            <div @click="$router.push('/course/'+item.id)" class="title">{{item.goods_name}}</div>
                        </div>
                    </td>
                    <td style="text-align:center;">￥{{item.user_sales_price|formatMoney}}</td>
                    <td style="text-align:center;color:#ff0000;">￥{{item.user_sales_price|formatMoney}}</td>
                </tr>
            </table>
            <!--优惠券选择-->
            <div class="moneyInfo">
                <div class="deduction">
                    <span class="s1">优惠券：</span>
                    <span class="s3">
            <el-select v-if="couponList.length > 0" v-model="couponId"
                       placeholder="请选择">
              <el-option
                  v-for="item in couponList"
                  :key="'couponItem'+item.id"
                  :value="item.id"
                  :label="item|formatCouponText"
              >
              </el-option>
            </el-select>
          </span>
                    <span class="s2" v-if="couponPay>0">-￥{{couponPay|formatMoney}}</span>
                </div>
                <!--余额-->
                <div class="deduction" v-if="leftBalance > 0">
                    <span class="s1">当前余额:</span>
                    <span class="s2">￥{{leftBalance|formatMoney}}</span>
                    <span class="s3" v-if="balancePay>0">,抵扣余额:{{balancePay|formatMoney}}</span>
                    <el-checkbox
                        style="margin-left:20px;"
                        v-model="useBalance"
                    >使用余额
                    </el-checkbox>
                </div>
            </div>

            <div class="paymentInfo" v-if="realPay>0">
                <div :class="payIndex === 1 ?'item active':'item'" @click="()=>{this.payIndex=1}">
                    <div class="name-box">
                        <div>
                            <span class="wxPay iconfont icon-weixinzhifu-">
                            </span>
                        </div>
                        <div>
                            <span class="s2">微信支付</span>
                        </div>
                    </div>
                    <div v-show="payIndex === 1" class="iconfont icon-xuanzhong"></div>
                </div>
                <div :class="payIndex === 2 ?'item active':'item'" @click="()=>{this.payIndex=2}">
                    <div class="name-box">
                        <div>
                            <span class="aliPay iconfont icon-zhifubao">
                            </span>
                        </div>
                        <div>
                            <span class="s2">支付宝支付</span>
                        </div>
                    </div>
                    <div v-show="payIndex === 2" class="iconfont icon-xuanzhong"></div>
                </div>
            </div>

            <div class="inFaceMoneyInfo" v-if="realPay>0">
                <div class="item">
                    <span>应付金额:</span>
                    <span class="s2">￥{{realPay|formatMoney}}</span>
                </div>
            </div>

            <div class="payNowBox">
                <div class="payNow" @click="submitOrder">立即支付</div>
            </div>
        </section>

        <!--微信支付二维码-->
        <div class="pay-box" v-show="showWxQrcode === 1">
            <div class="qrcode">
                <div class="close" @click="closeClick">
                    <span class="iconfont icon-times">
                    </span>
                </div>
                <div class="title">微信扫码支付</div>
                <div id="weixinPayQrcode" ref="weixinPayQrcode"></div>
                <div class="desc">使用手机微信扫码完成付款</div>
            </div>
        </div>

        <!--支付结果显示-->
        <div class="payresult-box" v-show="showPayResult===1">
            <div class="result">
                <div class="close" @click="closeResultClick">
                    <span class="iconfont icon-times">
                    </span>
                </div>
                <div class="steate">
                    <img src alt class="iconfont icon-zhengque1"/>
                    <span>支付成功</span>
                </div>
                <div class="buttons">
                    <a class="a1" @click="goOrder" href="javascript:void(0)">查看订单</a>
                    <a class="a2" @click="goHome" href="javascript:void(0)">返回首页</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {assets} from "@/api/user.js";
    import {weiXinPay, aliPay, orderPayState, createOrderByGoods} from "@/api/order.js";
    import QRCode from "qrcodejs2";


    export default {

        props: {
            //订单对象:amount=>int,orderItems=>array
            order: {
                type: Object,
            },
            //优惠券列表
            couponList: {
                type: Array,
            },
            //购物车id列表,如果是购物车创建订单提交订单到服务器时需要使用到
            cartIdList: {
                type: Array,
            }

        },

        data() {
            return {


                payIndex: 0, //默认不选择第三方支付
                showWxQrcode: 0, //显示微信支付二维码
                showPayResult: 0,

                orderAmount: 0, //订单总金额
                couponId: null, //选中的couponId,默认不使用优惠券
                orderItems: [],//订单子元素

                leftBalance: 0, //当前用户账户余额
                useBalance: false, //是否使用余额

                timer: 20 //定时器
            };
        },

        created() {
            this.orderAmount = this.order.amount;
            this.orderItems = this.order.orderItems;
            this.fetchUserBalance();
        },


        computed: {
            //优惠券支付金额
            couponPay: function () {
                let coupon = this.couponList.find((item) => {
                    return item.id === this.couponId
                });
                if (!coupon) return 0;
                let couponPay=0;
                if (coupon.c_type === 1) { //抵扣券
                    couponPay= coupon.deduction;
                } else if (coupon.c_type === 2) { //折扣券
                    couponPay= this.orderAmount * (1 - coupon.discount / 100);
                }
                if (couponPay>this.orderAmount){
                    couponPay=this.orderAmount;
                }
                return couponPay;
            },

            //余额支付金额:订单总金额-优惠券支付金额
            balancePay: function () {
                let balancePay = 0;
                if (this.useBalance === true) {//如果使用余额支付,计算出余额可抵扣金额
                    balancePay = this.orderAmount - this.couponPay;
                    //比对期望抵扣余额与当前账户余额
                    if (balancePay>this.leftBalance){
                        balancePay=this.leftBalance;
                    }
                }

                return balancePay;
            },
            //实际支付金额(第三方支付金额)
            realPay: function () {
                return this.orderAmount - this.couponPay - this.balancePay;
            },

        },

        methods: { 
            //提交订单
            submitOrder() {
                //支付方式选择判断
                if(!this.useBalance && this.payIndex==0) {
                    this.$message({
                        message: '请至少选择一种支付方式!',
                        type: 'warning'
                    });
                    return;
                }
                if (this.cartIdList && this.cartIdList.length > 0) {//結算购物车提交订单
                    const data = {
                        carts: this.cartIdList,
                        c_id: this.couponId,
                        balance_pay:this.balancePay,
                    };
                } else {//购买商品提交订单
                    let goods=this.order.orderItems[0];
                    const data={
                        g_id:goods.goods_id,
                        g_type:goods.goods_type,
                        balance_pay:this.balancePay,
                        c_id: this.couponId,
                    };
                    createOrderByGoods(data).then(rep => {
                        if (rep===-1)return;
                        if (rep.order_status===2){//支付成功
                            this.$message("支付成功");
                        }else if(rep.order_status===0){//未支付
                            if (this.payIndex===1){
                                this.weixinPayFun(rep.order_no);
                            }else if (this.payIndex===2){
                                this.aliPayFun(rep.order_no);
                            }
                        }
                    })
                }
            },
            //调起微信支付
            weixinPayFun: function (order_no) {
                weiXinPay(order_no).then(resp => {
                    if (resp !== -1) {
                        this.showWxQrcode = 1;
                        new QRCode(this.$refs["weixinPayQrcode"], {
                            text: resp,
                            width: 260,
                            height: 260,
                            colorDark: "#000000",
                            colorLight: "#ffffff",
                            correctLevel: QRCode.CorrectLevel.H
                        });
                        this.orderPayStateFun(order_no);
                    }
                });
            },
            //支付宝支付
            aliPayFun: function (order_no) {
                aliPay(order_no).then(resp => {
                    if (resp != -1) {
                        var newWindow = window.open();
                        newWindow.document.write(resp);
                        //弹出是否支付成功的弹框
                        this.$alert("是否已经支付成功?", "温馨提示", {
                            confirmButtonText: "确定",
                            callback: action => {
                                //不管是关闭，还是确定都执行这里
                                this.goOrder();
                            }
                        });
                        this.orderPayStateFun(order_no);
                    }
                });
            },
            //向服务器查询订单支付状态
            orderPayStateFun: function (order_no) {
                this.timer = setInterval(function () {
                    orderPayState(order_no).then(resp => {
                        if (resp != -1) {
                            this.showPayResult = 1;
                        }
                    });
                }, 6000);
            },


            //关闭微信二维码弹框
            closeClick: function () {
                this.showWxQrcode = 0;
                this.$refs.weixinPayQrcode.innerHTML = "";
                //跳转
                this.goOrder();
            },
            closeResultClick: function () {
                this.showPayResult = 0;
            },
            //去订单详情
            goOrder: function () {
                //清空定时器
                clearInterval(this.timer);
                this.$router.push(`/user/index/6`);
            },
            //跳转到首页
            goHome: function () {
                this.$router.push(`/`);
            },
            //调用服务器接口查询当前用户余额
            fetchUserBalance: function () {
                assets().then(resp => {
                    if (resp !== -1) {
                        this.leftBalance = resp.amount;
                    }
                });
            },


        },

    };
</script>


<style lang="scss" scoped>
    .cContent {
        width: 1200px;
        margin: 20px auto;
        background: #efefef;

        table {
            width: 100%;
            border-collapse: collapse;

            th {
                border: 1px solid white;
                padding: 10px 0;
                font-size: 14px;
                background: #e8f0fb;
                color: #3a3a3a;
            }

            td {
                border: 1px solid white;
                background: white;
                padding: 10px;
                font-size: 14px;

                .img-box {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                }

                img {
                    background: #efefef;
                    height: 90px;
                    width: 160px;
                    display: block;
                    border-radius: 10px;
                }

                .title {
                    margin: 0 10px;
                    color: #000000;
                    font-size: 1.6em;
                    font-weight: bold;
                    flex: 1;
                }
            }
        }

        .moneyInfo {
            background: white;
            text-align: right;
            padding: 15px 0;

            .deduction {
                background: #edf4fc;
                padding: 10px;
                color: #5b5b5b;
                font-size: 1.4em;

                .s2,
                .s3 {
                    color: #ff0000;
                    margin-left: 5px;
                    font-weight: bold;
                }

                .s3 {
                    margin-left: 0;
                }

                select {
                    margin-left: 20px;
                    border: 1px solid #313131;
                    border-radius: 5px;
                    padding: 2px 10px;
                    color: #000000;
                    margin-right: 60px;
                }
            }
        }

        .paymentInfo {
            text-align: right;
            justify-content: flex-end;
            padding: 0;
            display: flex;
            flex-direction: row;
            color: #333333;
            font-size: 1.4em;
            background: white;

            .item {
                cursor: pointer;
                overflow: hidden;
                border: 2px solid #d2d2d2;
                display: flex;
                flex-direction: row;
                padding: 6px 0;
                position: relative;
                border-radius: 5px;
                width: 130px;
                text-align: center;
                margin-left: 20px;

                .name-box {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    margin-left: 15px;

                    .wxPay {
                        font-size: 24px;
                        color: #21d12d;
                    }

                    .aliPay {
                        font-size: 24px;
                        color: #00aaee;
                    }

                    div {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;

                        .s2 {
                            font-size: 1.4em;
                            color: #2c2c2c;
                            margin-left: 6px;
                        }
                    }
                }
            }

            .icon-xuanzhong {
                display: block;
                position: absolute;
                bottom: -9px;
                right: -9px;
                background: transparent;
                color: #313131;
                font-size: 32px;
            }

            .active {
                border: 2px solid #313131;
                position: relative;
            }
        }

        .inFaceMoneyInfo {
            text-align: right;
            padding: 10px;
            background: white;

            span {
                font-size: 14px;
            }

            .s2 {
                color: red;
                font-weight: bold;
                font-size: 16px;
            }
        }

        .payNowBox {
            text-align: right;
            background: white;
            position: relative;
            height: 100px;

            .payNow {
                cursor: pointer;
                margin-top: 5px;
                background: #e30707;
                border-radius: 10px;
                color: white;
                padding: 8px 0;
                width: 156px;
                text-align: center;
                font-size: 1.6em;
                position: absolute;
                right: 0;
                top: 0;
            }
        }
    }

    //支付二维码弹出框
    .pay-box {
        background: #00000030;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        .qrcode {
            padding: 10px 50px;
            background: white;
            text-align: center;
            display: block;
            margin: 0 auto;
            border-radius: 10px;
            position: relative;

            .close {
                width: 40px;
                height: 40px;
                position: absolute;
                right: 10px;
                top: 10px;
                cursor: pointer;

                span {
                    color: #3f3f3f;
                }
            }

            .title {
                color: #141414;
                font-size: 1.6em;
                font-weight: bold;
                padding: 10px;
            }

            img {
                display: block;
                margin: 20px;
            }

            .desc {
                padding: 10px;
                color: #595959;
                font-size: 14px;
            }
        }
    }

    //支付结果显示
    .payresult-box {
        background: #00000030;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        .result {
            padding: 20px 40px;
            background: white;
            text-align: center;
            display: block;
            margin: 0 auto;
            border-radius: 10px;
            position: relative;

            .close {
                width: 40px;
                height: 40px;
                position: absolute;
                right: 10px;
                top: 10px;
                cursor: pointer;

                span {
                    color: #3f3f3f;
                }
            }

            .steate {
                padding: 30px 50px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;

                img {
                    height: 30px;
                    width: 30px;
                    display: block;
                    margin-right: 10px;
                    margin-top: 10px;
                }

                span {
                    font-size: 1.8em;
                    color: #151515;
                    font-weight: bold;
                }
            }

            .buttons {
                padding: 30px 20px;

                .a1 {
                    background: #313131;
                    padding: 10px 25px;
                    color: white;
                    border-radius: 5px;
                    font-size: 1.2em;
                }

                .a2 {
                    background: white;
                    padding: 10px 25px;
                    color: #313131;
                    border-radius: 5px;
                    font-size: 1.2em;
                    border: 1px solid #313131;
                    margin-left: 10px;
                }
            }
        }
    }
</style>
